import './CustomMarker.scss';

import { Popover } from 'antd';
import React from 'react';

import type { MarkerIconType } from './MarkerIcon';
import MarkerIcon from './MarkerIcon';

interface Props {
  icon?: string;
  content?: React.ReactNode;
  backgroundColor?: string;
  lat: number;
  lng: number;
  onClick?: () => void;
  selected?: boolean;
  popup?: React.ReactNode;
  clickableMarker: boolean;
  type: MarkerIconType;
}

export const CustomMarker = (props: Props) => {
  const { clickableMarker, popup, selected, content, type, onClick } = props;

  const renderPopover = () => {
    if (clickableMarker) {
      return (
        <Popover
          content={popup}
          open={selected}
          trigger="click"
          classNames={{ root: 'CustomMarker_Popover' }}
          // getPopupContainer={trigger => trigger.parentElement || document.body}
        >
          <span className={`CustomMarker_content ${type}`}>{content && content}</span>
        </Popover>
      );
    }

    return (
      <Popover
        trigger="hover"
        content={popup}
        classNames={{ root: 'CustomMarker_Popover' }}
        // getPopupContainer={trigger => trigger.parentElement || document.body}
      >
        <span className={`CustomMarker_content ${type}`}>{content && content}</span>
      </Popover>
    );
  };

  return (
    <div className={`CustomMarker ${selected ? 'selected' : ''} ${type}`} onClick={onClick}>
      <MarkerIcon type={type} selected={selected} />
      {popup
        ? renderPopover()
        : content && <span className={`CustomMarker_content ${type}`}>{content}</span>}
    </div>
  );
};
